// Overlay de connexion : piloté uniquement par l'état réel de chargement (aucun délai artificiel).
export function ConnectingOverlay({ message = "Connexion en cours…", sub }) {
  return (
    <div data-testid="connecting-overlay" role="status" aria-live="polite"
      className="fixed inset-0 z-[100] bg-[#0C1713]/95 backdrop-blur-sm grid place-items-center"
      style={{ animation: "nx-fade-in 180ms ease-out" }}>
      <div className="flex flex-col items-center">
        <div className="relative w-24 h-24">
          <div className="absolute inset-0 rounded-full border border-[#1B3028]" />
          <div className="absolute inset-0 rounded-full border-[1.5px] border-transparent border-t-[#C69C4A] border-r-[#C69C4A]/40"
            style={{ animation: "nx-spin 1.1s cubic-bezier(.45,.05,.55,.95) infinite" }} />
          <div className="absolute inset-[18px] rounded-2xl bg-[#C69C4A] text-[#0C1713] grid place-items-center font-serif-display font-bold text-2xl select-none">N</div>
        </div>
        <p data-testid="connecting-message" className="mt-6 text-sm text-stone-200 tracking-wide">{message}</p>
        {sub && <p className="mt-1 text-xs text-stone-500">{sub}</p>}
      </div>
      <style>{`@keyframes nx-spin{to{transform:rotate(360deg)}}@keyframes nx-fade-in{from{opacity:0}to{opacity:1}}`}</style>
    </div>
  );
}
